export const environment = {
  production: false,
  baseURL: 'https://api.erpnovo.pdvnow.com/v1',
  baseURLPDV: 'https://pdv-api-dev.magtechdev.com.br/api',
  sessionKey: 'erp-financeiro-session-dev',
  themeKey: 'erp-financeiro-theme-dev',
};
